import { useState } from 'react';
import { useNavigate } from 'react-router';

import { FormBuilderPreview } from '@/widgets/FormBuilder/FormBuilderPreview';
import { Schema } from '@/widgets/FormBuilder/types';

import LEGAL_ENTITY_SCHEMA from '@/shared/data/schemas/services/ARS02/LEGAL_ENTITY.json';
import PRIVATE_PERSON_SCHEMA from '@/shared/data/schemas/services/ARS02/PRIVATE_PERSON.json';
import { CorrespondenceType } from '@/shared/types';
import { Typography, Image, Tabs } from '@/shared/ui';

import { correspondenceType } from '@/modules/ars/pages/services/SearchIncomingCorrespondence/constants';

import { ROUTES_BY_SERVICE_CODE } from '@/router/config';

import { SERVICE_CODES } from '@/lib/consts';

import { IncomingCorrespondenceRequest } from '@/api/types';

import './IncomingCorrespondenceBanner.scss';

export const IncomingCorrespondenceBanner: React.FC = () => {
  const [activeTab, setActiveTab] = useState<CorrespondenceType>(CorrespondenceType.LEGAL_ENTITY);
  const navigate = useNavigate();

  const handleSubmit = (data: IncomingCorrespondenceRequest): void => {
    navigate(ROUTES_BY_SERVICE_CODE[SERVICE_CODES.SEARCH_INCOMING_CORRESPONDENCE], {
      state: { correspondenceStateData: data, correspondenceStateType: activeTab },
    });
  };

  return (
    <div className="container">
      <section className="incoming-correspondence-banner">
        <div className="incoming-correspondence-banner__wrapper">
          <Typography className="incoming-correspondence-banner__title" variant="H1">
            Пошук вхідної кореспонденції
          </Typography>

          <div className="incoming-correspondence-banner__form">
            <Tabs
              items={correspondenceType}
              activeKey={activeTab}
              onChange={(key) => setActiveTab(key as CorrespondenceType)}
            />
            <FormBuilderPreview
              schema={
                activeTab === 'legal_entity'
                  ? (LEGAL_ENTITY_SCHEMA as unknown as Schema)
                  : (PRIVATE_PERSON_SCHEMA as unknown as Schema)
              }
              onSubmit={handleSubmit}
            />
          </div>
          <div className="incoming-correspondence-banner__image">
            <Image src="/images/incoming_correspondence.svg" alt="letters photo" />
          </div>
        </div>
      </section>
    </div>
  );
};
